export default __webpack_public_path__ + "static/media/green-checkmark.80aef1eb.svg";